import { IdentifiedServerMetric, MetricsApi, ServerMetricData } from '@tableau/metrics-server-client-typescript/lib/src/p2';
import { MetricsRestApi, MetricsRestApiRequester } from '@tableau/metrics-server-client-typescript/lib/src/p2/restApi';

import { Module } from '../Module';

export class Metrics {
  private apiClient: MetricsApi;
  private $cookies: ng.cookies.ICookiesService;

  public static $inject = [
    '$cookies'
  ];

  constructor($cookies: ng.cookies.ICookiesService) {
    this.$cookies = $cookies;
    const serverUrl = 'https://i4y0eg6eik.execute-api.us-west-2.amazonaws.com/dev';
    const requester = new MetricsRestApiRequester(serverUrl, this.getApiKey());
    this.apiClient = new MetricsRestApi(requester);
  }

  private getApiKey(): string {
    return this.$cookies.get('MetricsApiKey');
  }

  public getAllMetrics(): Promise<ReadonlyArray<IdentifiedServerMetric>> {
    return this.apiClient.getAllMetrics();
  }

  public getMetricData(id: string): Promise<ServerMetricData> {
    return this.apiClient.getMetricData(id);
  }

  public deleteMetric(id: string): Promise<void> {
    return this.apiClient.deleteMetric(id);
  }
}

Module.instance().service('Metrics', Metrics);

